import {Injectable } from '@angular/core';

@Injectable()
export class DateParserService {

  public parseFromString(dateString: string): Date {
    return new Date(dateString + 'Z');
  }

  public parseFromLocalString(dateString: string): Date {
    return new Date(dateString);
  }

  public createDate(year: number, month: number, day: number): Date {
      return new Date(year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2) + ' 00:00.000Z');
  }

  public formatDateToItalian(dddd: Date): string{
    if (!dddd || ! dddd.toISOString ) {
      return '';
    }

    const df = dddd.toISOString();
    return df.substring(8, 10) + '/' + df.substring(5, 7) + '/' + df.substring(0, 4);
  }

  public formatDateStringToItalian(dateString: string): string {
    try {
      const a = new Date(dateString);
    } catch {
      return '';
    }

    return dateString.substring(8, 10) + '/' + dateString.substring(5, 7) + '/' + dateString.substring(0, 4);
  }

  public getDateFromItalianString(italianString: string) {
    return new Date(`${italianString.substr(6, 4)}-${italianString.substr(3, 2)}-${italianString.substr(0, 2)}T00:00:00.000Z`);
  }

  public formatTimeToItalian(dddd: Date): string {
    if (!dddd || !dddd.toLocaleTimeString()) {
      return '';
    }

    const df = dddd.toLocaleTimeString();
    return df;
  }

  public getTimeString(hours: number, minutes: number) {
    hours = Math.floor(hours || 0);
    minutes = minutes || 0;
    return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
  }

  public parseToMidnightUTCDate(d: Date) {
    d.setUTCFullYear(d.getFullYear());
    d.setUTCMonth(d.getMonth(), d.getDate());
    d.setUTCHours(0, 0, 0, 0);
    return d;
  }
}
